export default __webpack_public_path__ + "static/media/Poppins-SemiBold.24b955c0.svg";